// Best-effort client-side error reporter shared by every error boundary.
// Posts to the executor's POST /client-error endpoint (persisted to
// audit_log + Pino-logged at warn). Centralised so telemetry coverage
// doesn't depend on which boundary catches: scoped segment boundaries no
// longer bubble to global-error, so each must report independently.

// Derive the executor's HTTP URL from the WS env var so we don't need a
// second config knob in Vercel. Same swap-scheme as lib/exec-server.ts.
function execHttpUrl(): string | null {
  const ws = process.env['NEXT_PUBLIC_EXEC_URL'];
  if (!ws) return null;
  return ws.replace(/^ws:/, 'http:').replace(/^wss:/, 'https:').replace(/\/$/, '');
}

export function reportClientError(error: Error & { digest?: string }): void {
  const exec = execHttpUrl();
  if (!exec) return;
  try {
    const body = JSON.stringify({
      message: String(error.message ?? '').slice(0, 1024),
      stack: String(error.stack ?? '').slice(0, 8 * 1024),
      digest: error.digest ?? null,
      url: typeof window !== 'undefined' ? window.location.href : null,
      userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : null,
      ts: Date.now(),
    });
    // `keepalive: true` lets the request survive the error-boundary unmount;
    // we don't await the response.
    void fetch(`${exec}/client-error`, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body,
      keepalive: true,
    }).catch(() => undefined);
  } catch {
    // never let the reporter throw — that would mask the real error.
  }
}
